import DialogUpdateProfileImage from './DialogUpdateProfileImage'

export default DialogUpdateProfileImage
// eslint-disable-next-line import/export
export * from './DialogUpdateProfileImage'
